import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import IonIcon from './IonIcon';
import brandIcon from '../assets/brand-icon.png';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const handleNavClick = (e, targetId) => {
    if (location.pathname === '/' && targetId) {
      e.preventDefault();
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container nav-container">
        <Link to="/" className="logo">
          <img src={brandIcon} alt="Budge" className="logo-icon" />
          <span>Budge</span>
        </Link>

        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <a href="/#features" onClick={(e) => handleNavClick(e, 'features')}>Features</a>
          <a href="/#how-it-works" onClick={(e) => handleNavClick(e, 'how-it-works')}>How It Works</a>
          <a href="/#security" onClick={(e) => handleNavClick(e, 'security')}>Security</a>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms</Link>
        </div>

        <button className="nav-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle navigation">
          {isOpen ? <IonIcon name="close" size={24} /> : <IonIcon name="menu" size={24} />}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
